import "./index.css";

export function App() {
  return (
    <div className="logo-container">
      {/* Geometric N mark */}
      {/* <svg
        viewBox="0 0 245 513"
        fill="none"
        className="logo-mark"
        aria-hidden="true"
      >
        <path d="M143 41V512.549L102 471.549V0L143 41Z" fill="#e8ecf4" />
        <path d="M245 412.879L159 323.823V265.464L203 311.027V117.774H245V412.879Z" fill="#e8ecf4" />
        <path d="M84 187.799V246.159L45 205.774V396.774H0V100.814L84 187.799Z" fill="#e8ecf4" />
      </svg> */}

      {/* Text */}
      <svg
        viewBox="0 0 400 80"
        fill="none"
        className="logo-text"
        aria-label="NOVA SPARK Development"
      >
        <text
          x="200"
          y="38"
          textAnchor="middle"
          fontFamily="Montserrat, system-ui, sans-serif"
          fontSize="36"
          fontWeight="300"
          fill="#e8ecf4"
          letterSpacing="0.15em"
        >
          NOVA SPARK
        </text>
        <text
          x="200"
          y="68"
          textAnchor="middle"
          fontFamily="Montserrat, system-ui, sans-serif"
          fontSize="14"
          fontWeight="400"
          fill="#e8ecf4"
          letterSpacing="0.35em"
        >
          DEVELOPMENT
        </text>
      </svg>
    </div>
  );
}

export default App;
